import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import Badge from '../Badge';
import ThinDivider from '../ThinDivider';
import { level1Content } from '../../styles/shareableStyles';

export const Container = styled.div`
  position: relative;
  padding-top: 16px;
  ${level1Content};
`;

export const BetaIcon = styled(Badge)`
  margin-left: 8px;
  margin-top: 5px;
`;

export const BuilderFieldContainer = styled.div<{ $isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.5;
    cursor: not-allowed;
  `};
`;

const builderLabelStyles = css`
  flex: 0 0 auto;
  font-weight: 400;
  color: ${theme.colors.secondary800};
`;

export const BuilderFieldLabel = styled.div<{ $marginRight?: string }>`
  min-width: 0;
  margin-right: ${({ $marginRight }) => $marginRight || '8px'};
  ${builderLabelStyles};
`;

export const BuilderSubtitle = styled.div`
  flex: 0 0 auto;
  color: ${theme.colors.secondary800};
`;

export const InputLabel = styled.div`
  ${builderLabelStyles};
`;

export const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const HorizontalDivider = styled(ThinDivider).attrs(() => ({
  layout: 'horizontal',
  size: 'full',
}))``;

export const Part1 = styled(SectionColumn)`
  padding: 12px 24px;
`;

export const Part2 = styled(SectionColumn)`
  padding: 12px 24px 16px;
  border-top: 1px solid ${theme.colors.border};
`;

export const LabelAction = styled.div`
  display: inline-block;
  font: inherit;
  font-weight: 400;
  line-height: normal;
  color: ${theme.colors.secondary800};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  column-gap: 12px;
`;

export const ConnectorContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ConnectorWrapper = styled.div`
  flex: 0 0 auto;
  padding: 4px 8px;
  border-radius: 4px;
  text-align: center;
  font: inherit;
  font-weight: 400;
  line-height: normal;
  background-color: ${theme.colors.mainBlue};
  color: ${theme.colors.inverse};
`;
